module.exports = __webpack_public_path__ + "img/megafon-logo-mobile.7a4afcf5.svg";